import { Component, OnInit } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-csr',
  templateUrl: './csr.component.html',
  styleUrls: ['./csr.component.css']
})
export class CSRComponent implements OnInit {

  constructor(
    // private translate: TranslateService,
    private _mdr: MatDialogRef<CSRComponent>,
  ) { 
    localStorage.setItem("lang",'en')
    // translate.setDefaultLang(localStorage.getItem('lang')); 
  }

  ngOnInit(): void {
  }

  Close(){
    this._mdr.close(false)
  }

}
